export var CONTAINERS = {
  sm: {
    mobile: '100%',
    tablet_vertical: '520px',
    tablet_horizontal: '660px',
    desktop: '790px',
    desktop_large: '790px'
  },
  md: {
    mobile: '100%',
    tablet_vertical: '500px',
    tablet_horizontal: '800px',
    desktop: '960px',
    desktop_large: '1100px'
  },
  lg: {
    mobile: '100%',
    tablet_vertical: '500px',
    tablet_horizontal: '800px',
    desktop: '960px',
    desktop_large: '1100px'
  }
};